import type Alert from 'features/POSRegisters/interfaces/AlertInfo';
import type {AlertScanSubType} from 'features/POSRegisters/interfaces/AlertInfo';

export default function (alerts: Alert[], scanSubType: AlertScanSubType | AlertScanSubType[]) {
  return alerts?.filter(alert => {
    if (Array.isArray(scanSubType)) {
      return !!scanSubType.find(type => type === alert.scanSubType);
    } else {
      return alert.scanSubType === scanSubType;
    }
  });
}
